import { ErrorHandler, inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BugSplat } from 'bugsplat-ng';
import { AuthService } from '../auth/auth.service';
import { CapacitorService } from '../capacitor/capacitor.service';
import { LoggingService } from '../logging/logging.service';

@Injectable()
export class MyAngularErrorHandlerService implements ErrorHandler {
  private authService = inject(AuthService);
  private bugsplat = inject(BugSplat);
  private capacitorService = inject(CapacitorService);
  private router = inject(Router);

  constructor() {
    // TODO BG add to bugsplat
    window.addEventListener('unhandledrejection', (event) => {
      this.handleError(event.reason as Error);
    });
  }

  async handleError(error: Error): Promise<void> {
    const session = await this.authService.getSession();
    const sessionUser = session.data.session?.user;
    return this.bugsplat.post(error, {
      appKey: this.capacitorService.platform,
      email: sessionUser?.email,
      user: sessionUser?.id,
      description: this.router.url,
    });
  }
}

@Injectable()
export class NullErrorHandler implements ErrorHandler {
  private loggingService = inject(LoggingService);

  handleError(error: Error) {
    this.loggingService.error(error.message, error);
  }
}
